var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
var defaultImgSrc = 'https://sg-live.slatic.net/original/ebf238e7aa294b55f5198f2a709efa42.png';
var Avatar = (function (_super) {
    __extends(Avatar, _super);
    function Avatar(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            displaySrc: props.fallbackSrc
        };
        return _this;
    }
    Avatar.prototype.componentDidMount = function () {
        var _this = this;
        var src = this.props.src;
        if (!src) {
            return;
        }
        var img = new Image();
        img.onload = function () {
            _this.setState({
                displaySrc: src
            });
        };
        img.src = src;
    };
    Avatar.prototype.render = function () {
        var _a = this.props, className = _a.className, shape = _a.shape, alt = _a.alt;
        var displaySrc = this.state.displaySrc;
        return (React.createElement("div", { className: "simple-avatar " + shape + " " + className },
            React.createElement("img", { src: displaySrc, alt: alt })));
    };
    Avatar.defaultProps = {
        shape: 'square',
        src: '',
        className: '',
        fallbackSrc: defaultImgSrc,
        lazy: false
    };
    return Avatar;
}(React.Component));
export default Avatar;

//# sourceMappingURL=index.js.map
